import request from '@/axios'
import type { UserType, Coderesponse } from './types'

interface RoleParams {
  roleName: string
}

//获取验证码
export const getCodeApi = (): Promise<IResponse<string>> => {
  return request.get({
    url: '/captcha/code'
  })
}
export const loginApi = (data: {
  username: string
  password: string
  code: any
  // captchaId: string | null
  // state: string
}): Promise<IResponse<Coderesponse>> => {
  return request.post({
    url: '/ors-auth/login',
    data
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.delete({ url: '/ors-auth/logout' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/role/list2', params })
}

export const authorizeApi = (data: any) => {
  return request.post({ url: '/ors-auth/sys/oauth2/authorize', data })
}

//通过code获取登录各种token
export const getTokenByCodeApi = (data: {
  code: string
  grant_type: string
  redirect_uri: string
}): Promise<IResponse<any>> => {
  return request.post({
    url: '/ors-auth/oauth2/token',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
